module.exports = __webpack_public_path__ + "img/fight_type.90f046dc.png";